/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formpurpose_Startdate_Title2Inputs */

const ja_contact_formpurpose_startdate_title2 = /** @type {(inputs: Contact_Formpurpose_Startdate_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポンサーシップの開始時期`)
};

const en_contact_formpurpose_startdate_title2 = /** @type {(inputs: Contact_Formpurpose_Startdate_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsorship Start Date`)
};

/**
* | output |
* | --- |
* | "Sponsorship Start Date" |
*
* @param {Contact_Formpurpose_Startdate_Title2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formpurpose_startdate_title2 = /** @type {((inputs?: Contact_Formpurpose_Startdate_Title2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formpurpose_Startdate_Title2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formpurpose_startdate_title2(inputs)
	return en_contact_formpurpose_startdate_title2(inputs)
});
export { contact_formpurpose_startdate_title2 as "contact_formPurpose_startDate_title" }